export const containerNovaEntrega = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: '20px',
    padding: '5px',
    width: '100%',
    height: '100%'
}

export const sxLinhas = {
    justifyContent: 'flex-end'
}

export const boxIconButton = {
    border: '1px solid black',
    borderRadius: '10px',
    ":hover": {
        backgroundColor: 'transparent',
        color: '#600385',
        border: "1px solid #600385"
    }
}

export const styleImage = {
    width: 'auto',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '100%'
    // backgroundColor: 'rgb(255 255 255)',
    // borderRadius: '20px'
}

export const styleOther = {
    fontSize: '13px',
    color: 'white',
    fontWeight: '600'
}

export const sessionFotos = {
    display: 'flex',
    width: '700px',
    height: '220px',
    borderRadius: '10px',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    gap: '20px'
}

export const sessionDocument = {
    overflowY: 'auto',
    borderRadius: '10px',
    padding: '5px'
}

export const styleBoxImage = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: "center",
    position: "relative",
    justifyContent: 'center'
}
